import { useEffect, useState } from 'react';
import api from '@/api';
import { pcompany } from '@/proto/proto';
import { Link, useHistory } from 'react-router-dom';
import { Button, message, Select } from 'antd';
import { PATH_MAIN } from '@/constants/constant';
import { useAppDispatch } from '@/store';
import { getMe } from '@/features/account/accountSlice';

const CompanySelectPage = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [companyList, setCompanyList] = useState<pcompany.IPbCompany[]>([]);
  const [selectCompanyId, setSelectCompanyId] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    api.get('/company/all').then(({ data }) => {
      setCompanyList(data.company);
    });
  }, []);

  const sendCompanyJoinRequest = (companyId: string) => {
    setLoading(true);
    api
      .post('/company/user/join', 'pcompany.PbCompanyJoinRequest', { companyId })
      .then(({ data }) => {
        setLoading(false);
        message.success('가입 신청이 완료되었습니다.');
        dispatch(getMe());
        history.push(PATH_MAIN);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <div className="text-lg">회사를 선택하세요.</div>
      <Select showSearch className="w-full mb-5" onChange={(value: string) => setSelectCompanyId(value)}>
        {companyList.map((company) => {
          return (
            <Select.Option value={`${company.base?.id}`} key={`company-car-${company.base?.id}`}>
              {company.name}
            </Select.Option>
          );
        })}
      </Select>
      <Button
        type="primary"
        block
        loading={loading}
        onClick={() => sendCompanyJoinRequest(selectCompanyId)}
        disabled={selectCompanyId === '' || loading}
      >
        가입 신청하기
      </Button>
      <div className="text-xs text-gray-500 mt-5">해당하는 회사가 없으신가요?</div>
      <Link to="/company/register">회사 생성하기</Link>
    </div>
  );
};

export default CompanySelectPage;
